module.exports = __webpack_public_path__ + "assets/img/Brighten-Home-Loans-Website.12766efa.jpg";